<template >
  <div class="new-home-packs">
    <div class="pack-box trial-offer align-center" >
<!--      <p class="discover text-uppercase">-->
<!--        découvrez votre pack-->

<!--        <span class="arrow-down"></span>-->
<!--      </p>-->
      <h3>Profitez de votre offre <br> d'essai à <span class="purple-text">2€/2 mois</span></h3>
      <p class="text-uppercase purple-text">Vous bénéficiez de</p>
      <ul>
        <li>Votre cadeau de bienvenue au choix</li>
        <li>Vos magazines en version papier et/ou numérique </li>
        <li>Une assistance juridique, fiscale et technique illimitée</li>
        <li>12 guides pratiques au choix</li>
          <b-button v-if="isMobile" class="button is-primary next-button opcookies-button" @click="nextStep()">
              Demander votre pack
          </b-button>
      </ul>
    </div>
      <GiftChoiceDynamic v-if="box === 'dynamic'"></GiftChoiceDynamic>
      <GiftChoiceList v-if="box === 'list'" ></GiftChoiceList>
      <GiftChoiceTableau v-if="box === 'tableau'" ></GiftChoiceTableau>
      <GiftChoiceTableauSchool v-if="box === 'school'" ></GiftChoiceTableauSchool>
      <GiftChoiceTableauAndroid v-if="box === 'android'" ></GiftChoiceTableauAndroid>
      <GiftChoiceTableauLenovo v-if="box === 'tableau_lenovo_coque'" ></GiftChoiceTableauLenovo>
<!--      <GiftChoiceArchos v-if="box === 'tableau-archos'"></GiftChoiceArchos>-->
      <GiftChoiceCooking v-if="box === 'cooking'" ></GiftChoiceCooking>
      <GiftChoiceCooking2024 v-if="box === 'cooking2024'" ></GiftChoiceCooking2024>
  </div>
</template>
<script>
import mixin from "../../../components/form/steps/travel_step_mixin";
import GiftChoiceDynamic from "./GiftChoiceDynamic";
import GiftChoiceList from "../../_commons/fr/newComponents/GiftChoiceList";
import GiftChoiceTableau from "../../_commons/fr/newComponents/GiftChoiceTableau";
import GiftChoiceTableauSchool from "../../_commons/fr/newComponents/GiftChoiceTableauSchool";
import GiftChoiceTableauAndroid from "../../_commons/fr/newComponents/GiftChoiceTableauAndroid";
import GiftChoiceTableauLenovo from "../../_commons/fr/newComponents/GiftChoiceTableauLenovo";
import GiftChoiceArchos from "../../_commons/fr/newComponents/GiftChoiceArchos";
import GiftChoiceCooking from "../../_commons/fr/newComponents/GiftChoiceCooking";
import GiftChoiceCooking2024 from "../../_commons/fr/newComponents/GiftChoiceCooking2024";
export default {
    mixins: [mixin],
    components: {GiftChoiceCooking,GiftChoiceCooking2024, GiftChoiceTableau, GiftChoiceTableauSchool, GiftChoiceDynamic, GiftChoiceTableauAndroid, GiftChoiceList,GiftChoiceArchos,GiftChoiceTableauLenovo},
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        }
    },
};
</script>
